module.exports = __webpack_public_path__ + "static/media/클래스프렙_이용안내서_교수자.ea91a74c.pdf";